/*******************************************************
WNBA EVENT HANDLERS
This handles events for various interactions related to WNBA.
********************************************************/

import openTeamTrendsModal from './open-team-trends-modal';

export default function addWNBAEventHandlers() {

    $(document).on('click', '.tt-open-wnba', openTeamTrendsModal);
}
